import { useState, useEffect } from "react";

/**
 * Returns true when viewport width ≤ 767px.
 * Reacts to window resize via matchMedia listener.
 */
export const useIsMobile = () => {
  const [m, setM] = useState(() => window.matchMedia("(max-width: 767px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const h = e => setM(e.matches);
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  return m;
};
